import { useState } from "react";
import { Bell } from "lucide-react";
import { useLang } from "@/contexts/LangContext";
import { useNotificationsFeed } from "@/hooks/useNotificationsFeed";
import NotificationsModal from "@/components/NotificationsModal";

export default function NotificationsBell() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const { systemNotifications, unreadSystem, markSeen, hasMore, loadingMore, loadMore } =
    useNotificationsFeed();

  return (
    <>
      <button
        type="button"
        className="notifications-bell"
        aria-label={t("notif_bell_label")}
        data-testid="notifications-bell-btn"
        onClick={() => setOpen(true)}
      >
        <Bell size={14} />
        {unreadSystem ? <span className="notifications-bell-badge" aria-hidden="true" /> : null}
      </button>
      <NotificationsModal
        open={open}
        onClose={() => setOpen(false)}
        systemNotifications={systemNotifications}
        markSeen={markSeen}
        hasMore={hasMore}
        loadingMore={loadingMore}
        onLoadMore={loadMore}
      />
    </>
  );
}
